module.exports = __webpack_public_path__ + "img/9791130602660.d40c7646.jpg";